import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row ml-2 pb-1" }
const _hoisted_2 = {
  key: 0,
  class: "flex xs2"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex xs4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Channels:")
], -1)
const _hoisted_4 = { class: "layout gutter--sm" }
const _hoisted_5 = { class: "row ml-2" }

import { UserChannel } from "../models/Channel";
import { Subscription } from "../models/Subscription";
import { computed, onMounted, ref, watchEffect } from "vue";
import { useUserChannelsStore } from "../store/pinia_userChannel";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  props: {
  subscription: { type: Subscription, required: false },
  autoSave: { type: Boolean, required: false, default: true },
},
  emits: ["channels", "add", "remove"],
  setup(__props, { emit }) {

const props = __props

const userChannelsStore = useUserChannelsStore();
onMounted(() => {
  userChannelsStore.setupChannels();
});

/* global defineProps, defineEmits */



const channels = ref([] as UserChannel[]);
const activeSubscription = ref<Subscription>();

watchEffect(async () => {
  if (props.subscription) {
    activeSubscription.value = props.subscription;
    channels.value = await props.subscription.channels();
  }
});

const availableChannels = computed(() => {
  const myChannels = userChannelsStore.userChannels;
  const chans: UserChannel[] = [];
  for (let i = 0; i < myChannels.length; i++) {
    let cand = myChannels[i];
    let existing = channels.value.find((elem) => {
      return elem.id == cand.id;
    });
    if (!existing) {
      chans.push(cand);
    }
  }
  return chans;
});

const removeChannel = async (chan: UserChannel) => {
  if (channels.value.length < 2) {
    alert("You can't remove the last channel on a subscription");
  } else {
    let text = `Are you sure you want to remove '${chan.name} from this subscription?`;
    if (confirm(text) == true) {
      if (props.autoSave && activeSubscription.value)
        await chan.removeSubscription(activeSubscription.value);
      const idx = channels.value.findIndex((c) => c.id == chan.id);
      if (idx != -1) {
        channels.value.splice(idx, 1);
        emit("remove", chan.value);
      }
      emit("channels", channels.value);
    }
  }
};
const addChannel = async (chan: UserChannel) => {
  if (props.autoSave && activeSubscription.value)
    await chan.addSubscription(activeSubscription.value);
  channels.value.push(chan);
  emit("add", chan.value);
  emit("channels", channels.value);
};

return (_ctx: any,_cache: any) => {
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_button_dropdown = _resolveComponent("va-button-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(availableChannels).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_va_button_dropdown, {
              "right-icon": "",
              icon: "add",
              class: "mr-2 mb-2",
              color: "secondary",
              size: "small"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableChannels), (channel) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: channel.id,
                    class: "flex pb-1"
                  }, [
                    _createVNode(_component_va_chip, {
                      style: {"font-size":"x-small"},
                      size: "small",
                      color: "secondary",
                      icon: channel.providerIcon,
                      onClick: ($event: any) => (addChannel(channel))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(channel.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["icon", "onClick"])
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channels.value, (channel) => {
          return (_openBlock(), _createElementBlock("div", {
            key: channel.id,
            class: "flex xs6"
          }, [
            _createVNode(_component_va_chip, {
              style: {"font-size":"x-small"},
              icon: channel.providerIcon,
              size: "small",
              closeable: "",
              "onUpdate:modelValue": ($event: any) => (removeChannel(channel))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(channel.name), 1)
              ]),
              _: 2
            }, 1032, ["icon", "onUpdate:modelValue"])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})